import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount } from 'vue'

import { setApiToken } from '@/api'
import AppFooter from '@/components/widgets/AppFooter.vue'
import AppHeader from '@/components/widgets/AppHeader.vue'
import { useAuthStore } from '@/store/bowler-app/auth'
import { usePreferencesStore } from '@/store/preferences'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const preferences = usePreferencesStore()

onBeforeMount((): void => {
  setApiToken(useAuthStore().accessToken)
  preferences.setLocale(preferences.locale)
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createVNode(_component_RouterView),
    _createVNode(AppFooter)
  ], 64))
}
}

})